import ApolloClient       from 'apollo-client';
import env                from '../env';
import { UserSession }    from '../types';
import { createHttpLink } from 'apollo-link-http';
import { setContext }     from 'apollo-link-context';
import { InMemoryCache }  from 'apollo-cache-inmemory';
import { concat }         from 'apollo-link';

export function createClient(session: UserSession): ApolloClient<{}> {
    const httpLink = createHttpLink({ uri: env.MESSAGE_TEMPLATE_HOST });

    const authMiddleware = setContext(async (req, { headers }) => ({
        headers: {
            ...headers,
            authorization: `Bearer ${session.token}`
        }
    }));

    const client = new ApolloClient({
        link: concat(authMiddleware, httpLink),
        cache: new InMemoryCache()
    });

    return client;
}



// WEBPACK FOOTER //
// ./src/services/MessageTemplatesService.ts